import XLSX from "xlsx";
import DateUtil from "@/util/DateUtil.js";

const list = {
  components() {
    return [
      {
        component: "search-start-end",
        label: "작성일",
        value: "date",
        query: { ss: "startDate", ee: "endDate" },
        options: {
          default: { sd: "", ed: "" },
        },
      },
      {
        component: "search-select-field",
        label: "사업장",
        value: "field",
        query: { f_id: "fieldId", f_name: "fieldName" },
        options: {
          default: { fieldId: "", fieldName: "" },
        },
      },
      {
        component: "search-column-keyword",
        label: "검색조건",
        value: "column",
        query: { ck_t: "head", ck_k: "keyword" },
        options: {
          hiddenList: ["사업장명", "연도", "월", "결과서 첨부"],
          boardId: 845,
        },
      },
    ];
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    //  검색일
    if (search.date) {
      conditions.push({ key: "created_at", operator: ">=", value: search.date.startDate });
      conditions.push({ key: "created_at", operator: "<", value: search.date.endDate ? new Date(search.date.endDate).addDays(1).format("yyyy-MM-dd") : "" });
    }

    // 사업장 — 실제로 선택된 경우에만 필터링한다.
    // (미선택 시 fieldId 가 빈 문자열이라, 그대로 보내면 field_id = '' 로 0건이 된다)
    if (search.field && search.field.fieldId) {
      conditions.push({ key: "body.stdInfo.field_id", operator: "=", value: search.field.fieldId });
    }

    //  검색조건
    const heads = list.getHead().map((e) => {
      return { [e.name]: e.key };
    });
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({ key: types[search.column.head], operator: "LIKE", value: `%${search.column.keyword}%` });
    }
    return conditions;
  },

  /**
   * 결재 문서 조회 조건을 설정하기 위함
   */
  getOptions: () => {
    return {
      /**
       * all: 전체 결재문서
       * pending_or_approved: 진행중 또는 승인된 결재문서
       */
      // type: 'all',
      /**
       * 1: temp(임시작성),
       * 2: registered(등록됨),
       * 3: ongoing(진행중),
       * 4: approved(승인됨)
       * 5: rejected(반려됨)*/
      statusIds: [4],
    };
  },

  /**
   * 목록을 불러온 이후 실제 데이터에 값을 저장하기 전에 실행되는 함수 ( this.listAll = response.data 하기 전 )
   * @param response : 목록데이터
   * @param options : 목록데이터를불러올때사용한옵션
   * @returns {Promise<*>}
   */
  prefixFunc: async (vue, response, options) => {
    return response;
  },

  getHead: () => {
    return [
      {
        name: "사업장명",
        key: "body.stdInfo.field_name",
      },
      {
        name: "업체명",
        key: "body.안전작업허가서정보.작업업체명.com_name",
      },
      {
        name: "공사/작업명",
        key: "body.안전작업허가서정보.공사작업명",
      },
      {
        name: "작업기간",
        key: "body.subInfo.종사자의견",
      },
      {
        name: "발주부서",
        key: "body.stdInfo.발주부서.com_name",
      },
      {
        name: "작성자",
        key: "body.stdInfo.writer_name",
      },
      {
        name: "작성일",
        key: "created_at",
      },
    ];
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0:
          return func.getContent(value).stdInfo.field_name; // 사업장명
        case 1:
          return func.getContent(value).안전작업허가서정보.작업업체명.com_name; // 업체명
        case 2:
          return func.getContent(value).안전작업허가서정보.공사작업명; // 공사/작업명
        case 3:
          if (func.getContent(value).안전작업허가서정보.작업기간.sDate || func.getContent(value).안전작업허가서정보.작업기간.sDate)
            return `${func.getContent(value).안전작업허가서정보.작업기간.sDate} ~ ${func.getContent(value).안전작업허가서정보.작업기간.eDate}`; // 실시기간
          else return "";
        case 4:
          return func.getContent(value).stdInfo.발주부서.com_name; // 부서명
        case 5:
          return func.getContent(value).stdInfo.writer_name; // 작성자
        case 6:
          return func.getCreatedDate(value.created_at); // 작성일
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
  customExcelDownload: (data, fileName, allList = []) => {
    console.log({ fileName });

    const wb = XLSX.utils.book_new();

    const header = ["No.", "공장명", "업체명", "공사/작업명", "작업시작", "작업종료", "출입인원", "발주부서", "공사담당", "작성자", "작성일"];

    const ws_data = [header];

    const dataToProcess = allList && allList.length > 0 ? allList : data;

    dataToProcess.forEach((_d, index) => {
      try {
        let postContent = null;
        if (_d.post_content) {
          postContent = JSON.parse(_d.post_content);
        }

        const info = postContent ? postContent.body.안전작업허가서정보 : null;

        const row = [
          index + 1,
          info ? info.공장명 || "" : "",
          info ? (info.작업업체명 ? info.작업업체명.com_name : "") : "",
          info ? info.공사작업명 || "" : "",
          info ? (info.작업기간 ? info.작업기간.sDate || "" : "") : "",
          info ? (info.작업기간 ? info.작업기간.eDate || "" : "") : "",
          postContent ? (Array.isArray(postContent.body.공사인원Table) ? postContent.body.공사인원Table.length : 0) : 0,
          postContent ? (postContent.body.stdInfo && postContent.body.stdInfo.발주부서 ? postContent.body.stdInfo.발주부서.com_name : "") : "",
          postContent ? (postContent.body.담당 ? postContent.body.담당.검토자 || "" : "") : "",
          _d.post.author ? _d.post.author.name || "" : "",
          _d.created_at || "",
        ];
        ws_data.push(row);
      } catch (e) {
        console.error("엑셀 데이터 처리 중 오류:", e);
        ws_data.push([index + 1, "", "", "", "", "", 0, "", "", "", ""]);
      }
    });

    const ws = XLSX.utils.aoa_to_sheet(ws_data);
    XLSX.utils.book_append_sheet(wb, ws, "안전작업허가서");
    XLSX.writeFile(wb, `${fileName}.xlsx`);
  },
};
export default list;
